import { render } from "./SocialAndWork.vue?vue&type=template&id=2bc2d96c"
import script from "./SocialAndWork.vue?vue&type=script&lang=js"
export * from "./SocialAndWork.vue?vue&type=script&lang=js"

import "./SocialAndWork.vue?vue&type=style&index=0&id=2bc2d96c&lang=scss"
script.render = render

export default script